import moment from 'moment';

export const getTimeSpentSince = (startDate: Date) => {
  const millisecondsSpent = moment.duration(moment(new Date()).diff(moment(startDate))).asMilliseconds();
  return moment.utc(millisecondsSpent).format('HH:mm:ss');
};
